export default __webpack_public_path__ + "static/media/0046.9572b314.png";